import { blogsActions } from "./blogs";
import { userActions } from "./user";
import { clientsActions } from "./clients";
import { clientActions } from "./client";
import { clientContactsActions } from "./client-contacts";
import { coreActions } from "./core";
import { projectActions } from "./project";
import { projectsActions } from "./projects";
import { productsActions } from "./products";
import { reportsActions } from "./reports";
import { reportOptionsActions } from "./report-options";
import { clipTrayActions } from "./clip-tray";
import { authorActions } from "./author";
import { boardActions } from "./board";
import { boardsActions } from "./boards";
import columns, { columnsActions } from "./columns";
import { ticketActions } from "./ticket"
import { selectedBinActions } from "./selected-bin";

import BlogsReducer from "./blogs";
import UserReducer from "./user";
import ClientsReducer from "./clients";
import ClientReducer from "./client";
import clientContactsReducer from "./client-contacts";
import CoreReducer from "./core";
import ProjectReducer from "./project";
import ProjectsReducer from "./projects";
import ProductsReducer from "./products";
import reportsReducer from "./reports";
import reportOptionsReducer from "./report-options";
import ClipTrayReducer from "./clip-tray";
import { combineReducers } from "redux";
import authorReducer from "./author";
import boardReducer from "./board";
import boardsReducer from "./boards";
import columnsReducer from "./columns"
import ticketReducer from "./ticket"
import SelectedBinReducer from "./selected-bin";

const actions = {
  blogs: blogsActions,
  user: userActions,
  clients: clientsActions,
  client: clientActions,
  clientContacts: clientContactsActions,
  core: coreActions,
  project: projectActions,
  projects: projectsActions,
  products: productsActions,
  reports: reportsActions,
  reportOptions: reportOptionsActions,
  clipTray: clipTrayActions,
  author :  authorActions,
  board: boardActions,
  boards: boardsActions,
  columns: columnsActions,
  ticket: ticketActions,
  selectedBin: selectedBinActions
};

const rootReducer = combineReducers({
  blogs: BlogsReducer,
  user: UserReducer,
  clients: ClientsReducer,
  client: ClientReducer,
  clientContacts: clientContactsReducer,
  core: CoreReducer,
  project: ProjectReducer,
  projects: ProjectsReducer,
  products: ProductsReducer,
  reports: reportsReducer,
  reportOptions: reportOptionsReducer,
  clipTray: ClipTrayReducer,
  author: authorReducer,
  board: boardReducer,
  boards: boardReducer,
  columns: columnsReducer,
  ticket: ticketReducer,
  selectedBin: SelectedBinReducer
});

export { rootReducer, actions };
